import { createContext } from 'react';

export const ScreenPropsContext = createContext();